/**
 * Generated from ch5_p14.fla
 */
export function ch5_p14(this: Ich5_p14) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly.call(holly[0] as Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly);
		holly[0].x = 622.25;
		holly[0].y = 530.5;
		holly[0].width = 461.50;
		holly[0].height = 475.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly.call(holly[1] as Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly);
		holly[1].x = 670;
		holly[1].y = 768;
		holly[1].width = 570.00;
		holly[1].height = 509.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const bg = this.bg;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_horse.call(this.horse);
	horse.x = 822.75;
	horse.y = 426.5;
	horse.width = 72.50;
	horse.height = 164.50;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const balloonLightBlue = this.balloonLightBlue;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonlblue.call(this.balloonLightBlue);
	balloonLightBlue.x = 710;
	balloonLightBlue.y = 240.5;
	balloonLightBlue.width = 94.00;
	balloonLightBlue.height = 237.00;
	balloonLightBlue.alpha = 1.00;
	if (balloonLightBlue.onLayout) balloonLightBlue.onLayout();
	const balloonYellow = this.balloonYellow;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonyellow.call(this.balloonYellow);
	balloonYellow.x = 935.25;
	balloonYellow.y = 114.25;
	balloonYellow.width = 76.50;
	balloonYellow.height = 228.50;
	balloonYellow.alpha = 1.00;
	if (balloonYellow.onLayout) balloonYellow.onLayout();
	const balloonBlue = this.balloonBlue;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonblue.call(this.balloonBlue);
	balloonBlue.x = 835.75;
	balloonBlue.y = 201.75;
	balloonBlue.width = 109.50;
	balloonBlue.height = 280.50;
	balloonBlue.alpha = 1.00;
	if (balloonBlue.onLayout) balloonBlue.onLayout();
	const balloonRed = this.balloonRed;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonred.call(this.balloonRed);
	balloonRed.x = 621.5;
	balloonRed.y = 146.5;
	balloonRed.width = 82.00;
	balloonRed.height = 263.00;
	balloonRed.alpha = 1.00;
	if (balloonRed.onLayout) balloonRed.onLayout();
	const balloonGreen = this.balloonGreen;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_ballongreen.call(this.balloonGreen);
	balloonGreen.x = 991.25;
	balloonGreen.y = 193.5;
	balloonGreen.width = 105.50;
	balloonGreen.height = 218.00;
	balloonGreen.alpha = 1.00;
	if (balloonGreen.onLayout) balloonGreen.onLayout();
	const balloons = this.balloons;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_balloons.call(this.balloons);
	balloons.x = 921.75;
	balloons.y = 121.75;
	balloons.width = 381.50;
	balloons.height = 243.50;
	balloons.alpha = 1.00;
	if (balloons.onLayout) balloons.onLayout();
	const tyler = this.tyler;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_tyler.call(this.tyler);
	tyler.x = 1114;
	tyler.y = 714;
	tyler.width = 382.00;
	tyler.height = 512.00;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const tylerBack = this.tylerBack;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerback.call(this.tylerBack);
	tylerBack.x = 966.5;
	tylerBack.y = 768;
	tylerBack.width = 435.00;
	tylerBack.height = 622.00;
	tylerBack.alpha = 1.00;
	if (tylerBack.onLayout) tylerBack.onLayout();
	const tylerFront = this.tylerFront;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerfront.call(this.tylerFront);
	tylerFront.x = 887.5;
	tylerFront.y = 435;
	tylerFront.width = 194.00;
	tylerFront.height = 67.50;
	tylerFront.alpha = 1.00;
	if (tylerFront.onLayout) tylerFront.onLayout();
	const grass = this.grass;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetGrass.call(this.grass);
	grass.x = 575.75;
	grass.y = 517.75;
	grass.width = 479.50;
	grass.height = 374.50;
	grass.alpha = 1.00;
	if (grass.onLayout) grass.onLayout();
	const bush = this.bush;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bushfront.call(this.bush);
	bush.x = 393;
	bush.y = 558.75;
	bush.width = 738.00;
	bush.height = 418.50;
	bush.alpha = 1.00;
	if (bush.onLayout) bush.onLayout();
	const frameRight = this.frameRight;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframerline.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 267.75;
	linesRight.width = 58.00;
	linesRight.height = 116.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLline.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 405.25;
	linesLeft.width = 90.50;
	linesLeft.height = 219.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bg(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_horse(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonlblue(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonlblue) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_balloonlblue", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonyellow(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonyellow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_balloonyellow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonblue(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonblue) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_balloonblue", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonred(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonred) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_balloonred", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_ballongreen(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_ballongreen) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_ballongreen", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_balloons(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_balloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p15_balloons", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_tyler(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerback(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerback) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p15_tylerback", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p15_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerfront(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p15_tylerfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetGrass(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetGrass) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grass", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bushfront(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bushfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p14_bushfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeRframe(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframerline(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframerline) {
	if (this.setLayoutTexture) this.setLayoutTexture("rline", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLframe(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLline(this: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLline) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lline", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p14Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p14Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p14Sprite extends Ich5_p14Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p14Text extends Ich5_p14Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p14Polygon extends Array<number> {
}
interface Ich5_p14 {
	readonly holly: Ich5_p14Array<Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly|Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly>;
	readonly bg: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bg;
	readonly horse: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_horse;
	readonly balloonLightBlue: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonlblue;
	readonly balloonYellow: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonyellow;
	readonly balloonBlue: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonblue;
	readonly balloonRed: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonred;
	readonly balloonGreen: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_ballongreen;
	readonly balloons: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_balloons;
	readonly tyler: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_tyler;
	readonly tylerBack: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerback;
	readonly tylerFront: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerfront;
	readonly grass: Ich5_p14_hh_ch5_72dpi_p01415psdAssetGrass;
	readonly bush: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bushfront;
	readonly frameRight: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeRframe;
	readonly linesRight: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframerline;
	readonly frameLeft: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLframe;
	readonly linesLeft: Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLline;
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bg extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_horse extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonlblue extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonyellow extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonblue extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_balloonred extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_ballongreen extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_balloons extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_tyler extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerback extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_holly extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_holly extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p15_tylerfront extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetGrass extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_bushfront extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeRframe extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframerline extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLframe extends Ich5_p14Sprite {
}
interface Ich5_p14_hh_ch5_72dpi_p01415psdAssetch5_p14_wcframeLline extends Ich5_p14Sprite {
}
